import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { App } from './components/App/App'
import { CssBaseline, ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { theme } from './theme'
import { FlightDeckProvider } from './context/FlightDeckContext'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { Settings } from 'luxon'

const SENTRY_DSN = process.env.REACT_APP_MP_SENTRY_DSN
const SENTRY_ENVIRONMENT = process.env.REACT_APP_MP_SENTRY_ENVIRONMENT

Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new BrowserTracing()],
    enabled: !!SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
})

Settings.defaultLocale = 'de'

ReactDOM.render(
    <>
        <CssBaseline />
        <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
                <StyledThemeProvider theme={theme}>
                    <FlightDeckProvider>
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </FlightDeckProvider>
                </StyledThemeProvider>
            </MuiThemeProvider>
        </StyledEngineProvider>
    </>,
    document.getElementById('root'),
)
